import React, { useState, useEffect } from 'react';
import axios from 'axios';

const WeatherWidget = () => {
    const [weather, setWeather] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [city, setCity] = useState(null);
    const [showCityInput, setShowCityInput] = useState(false);
    const [locationDetected, setLocationDetected] = useState(false);
    const [detectingLocation, setDetectingLocation] = useState(true);

    // City coordinates for Open-Meteo API
    const citiesCoordinates = {
        'Mumbai': { lat: 19.0760, lon: 72.8777, name: 'Mumbai' },
        'Delhi': { lat: 28.6139, lon: 77.2090, name: 'Delhi' },
        'Bangalore': { lat: 12.9716, lon: 77.5946, name: 'Bangalore' },
        'Chennai': { lat: 13.0827, lon: 80.2707, name: 'Chennai' },
        'Kolkata': { lat: 22.5726, lon: 88.3639, name: 'Kolkata' },
        'Hyderabad': { lat: 17.3850, lon: 78.4867, name: 'Hyderabad' },
        'Pune': { lat: 18.5204, lon: 73.8567, name: 'Pune' },
        'Ahmedabad': { lat: 23.0225, lon: 72.5714, name: 'Ahmedabad' },
        'Jaipur': { lat: 26.9124, lon: 75.7873, name: 'Jaipur' },
        'Lucknow': { lat: 26.8467, lon: 80.9462, name: 'Lucknow' },
        'Nagpur': { lat: 21.1458, lon: 79.0882, name: 'Nagpur' },
        'Indore': { lat: 22.7196, lon: 75.8577, name: 'Indore' },
        'Bhopal': { lat: 23.2599, lon: 77.4126, name: 'Bhopal' },
        'Surat': { lat: 21.1702, lon: 72.8311, name: 'Surat' },
        'Vadodara': { lat: 22.3072, lon: 73.1812, name: 'Vadodara' },
        'Chandigarh': { lat: 30.7333, lon: 76.7794, name: 'Chandigarh' },
        'Goa': { lat: 15.2993, lon: 74.1240, name: 'Goa' },
        'Kochi': { lat: 9.9312, lon: 76.2673, name: 'Kochi' },
        'Thiruvananthapuram': { lat: 8.5241, lon: 76.9366, name: 'Thiruvananthapuram' },
        'Coimbatore': { lat: 11.0168, lon: 76.9558, name: 'Coimbatore' },
        'Visakhapatnam': { lat: 17.6868, lon: 83.2185, name: 'Visakhapatnam' },
        'Patna': { lat: 25.5941, lon: 85.1376, name: 'Patna' },
        'Ranchi': { lat: 23.3441, lon: 85.3096, name: 'Ranchi' },
        'Bhubaneswar': { lat: 20.2961, lon: 85.8245, name: 'Bhubaneswar' },
        'Guwahati': { lat: 26.1445, lon: 91.7362, name: 'Guwahati' },
        'New York': { lat: 40.7128, lon: -74.0060, name: 'New York' },
        'London': { lat: 51.5074, lon: -0.1278, name: 'London' },
        'Dubai': { lat: 25.2048, lon: 55.2708, name: 'Dubai' },
        'Singapore': { lat: 1.3521, lon: 103.8198, name: 'Singapore' },
        'Tokyo': { lat: 35.6895, lon: 139.6917, name: 'Tokyo' },
        'Sydney': { lat: -33.8688, lon: 151.2093, name: 'Sydney' },
        'Paris': { lat: 48.8566, lon: 2.3522, name: 'Paris' },
        'Berlin': { lat: 52.5200, lon: 13.4050, name: 'Berlin' },
        'Toronto': { lat: 43.6532, lon: -79.3832, name: 'Toronto' },
        'Los Angeles': { lat: 34.0522, lon: -118.2437, name: 'Los Angeles' },
        'Chicago': { lat: 41.8781, lon: -87.6298, name: 'Chicago' },
        'Shanghai': { lat: 31.2304, lon: 121.4737, name: 'Shanghai' },
        'Hong Kong': { lat: 22.3193, lon: 114.1694, name: 'Hong Kong' },
        'Bangkok': { lat: 13.7367, lon: 100.5231, name: 'Bangkok' },
        'Kuala Lumpur': { lat: 3.1390, lon: 101.6869, name: 'Kuala Lumpur' },
        'Moscow': { lat: 55.7558, lon: 37.6173, name: 'Moscow' },
        'Istanbul': { lat: 41.0082, lon: 28.9784, name: 'Istanbul' },
        'Rome': { lat: 41.9028, lon: 12.4964, name: 'Rome' },
        'Madrid': { lat: 40.4168, lon: -3.7038, name: 'Madrid' },
        'Amsterdam': { lat: 52.3676, lon: 4.9041, name: 'Amsterdam' },
        'Vienna': { lat: 48.2082, lon: 16.3738, name: 'Vienna' },
        'Zurich': { lat: 47.3769, lon: 8.5417, name: 'Zurich' },
        'Seoul': { lat: 37.5665, lon: 126.9780, name: 'Seoul' },
        'Beijing': { lat: 39.9042, lon: 116.4074, name: 'Beijing' }
    };

    const popularCities = Object.keys(citiesCoordinates).map(cityName => ({
        name: cityName,
        displayName: cityName
    }));

    // Get city coordinates
    const getCityCoordinates = (cityName) => {
        return citiesCoordinates[cityName] || citiesCoordinates['Mumbai'];
    };

    // Function to get user's current location
    const getUserLocation = () => {
        setDetectingLocation(true);
        setError(null);

        if (!navigator.geolocation) {
            setError('Geolocation not supported');
            setCity('Mumbai');
            setDetectingLocation(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                await getCityFromCoordinates(latitude, longitude);
                setDetectingLocation(false);
            },
            (error) => {
                console.error('Location error:', error);
                setDetectingLocation(false);
                setLocationDetected(false);
                setCity('Mumbai');
                setError('Using default location');
                setTimeout(() => setError(null), 3000);
            },
            { timeout: 10000, enableHighAccuracy: true }
        );
    };

    // Get city name from coordinates
    const getCityFromCoordinates = async (lat, lon) => {
        try {
            const response = await axios.get(
                `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}&zoom=10`
            );
            const address = response.data.address;
            let cityName = address.city || address.town || address.village || address.municipality;

            if (!cityName) {
                cityName = address.state || address.county || 'Mumbai';
            }

            cityName = cityName.trim();

            // Check if we have coordinates for this city
            if (!citiesCoordinates[cityName]) {
                cityName = 'Mumbai';
            }

            setLocationDetected(true);
            setCity(cityName);
        } catch (err) {
            console.error('Reverse geocoding error:', err);
            setLocationDetected(false);
            setCity('Mumbai');
        }
    };

    // Fetch weather using Open-Meteo API (No API key required!)
    const fetchWeather = async (cityName) => {
        if (!cityName) return;

        setLoading(true);
        setError(null);

        const coords = getCityCoordinates(cityName);

        try {
            // Using Open-Meteo API - completely free, no API key needed
            const response = await axios.get(
                `https://api.open-meteo.com/v1/forecast?latitude=${coords.lat}&longitude=${coords.lon}&current=temperature_2m,relative_humidity_2m,weather_code,wind_speed_10m&timezone=auto`
            );

            const data = response.data.current;
            const temp = Math.round(data.temperature_2m);
            const humidity = data.relative_humidity_2m;
            const windSpeed = Math.round(data.wind_speed_10m);
            const weatherCode = data.weather_code;

            // Map weather codes to descriptions and icons
            const weatherMap = {
                0: { desc: 'Clear sky', icon: '☀️' },
                1: { desc: 'Mainly clear', icon: '🌤️' },
                2: { desc: 'Partly cloudy', icon: '⛅' },
                3: { desc: 'Overcast', icon: '☁️' },
                45: { desc: 'Fog', icon: '🌫️' },
                48: { desc: 'Depositing rime fog', icon: '🌫️' },
                51: { desc: 'Light drizzle', icon: '🌧️' },
                53: { desc: 'Moderate drizzle', icon: '🌧️' },
                55: { desc: 'Dense drizzle', icon: '🌧️' },
                61: { desc: 'Light rain', icon: '🌧️' },
                63: { desc: 'Moderate rain', icon: '🌧️' },
                65: { desc: 'Heavy rain', icon: '🌧️' },
                71: { desc: 'Light snow', icon: '❄️' },
                73: { desc: 'Moderate snow', icon: '❄️' },
                75: { desc: 'Heavy snow', icon: '❄️' },
                95: { desc: 'Thunderstorm', icon: '⛈️' }
            };

            const weatherInfo = weatherMap[weatherCode] || { desc: 'Unknown', icon: '🌍' };

            // Get sunrise/sunset times
            const sunResponse = await axios.get(
                `https://api.sunrise-sunset.org/json?lat=${coords.lat}&lng=${coords.lon}&formatted=0`
            );

            const sunriseTime = new Date(sunResponse.data.results.sunrise);
            const sunsetTime = new Date(sunResponse.data.results.sunset);
            const sunrise = sunriseTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
            const sunset = sunsetTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            setWeather({
                temp,
                humidity,
                windSpeed,
                description: weatherInfo.desc,
                icon: weatherInfo.icon,
                sunrise,
                sunset,
                city: cityName
            });
        } catch (err) {
            console.error('Weather fetch error:', err);
            setError('Could not fetch weather');
            setWeather({
                temp: '--',
                humidity: '--',
                windSpeed: '--',
                description: 'Weather data unavailable',
                icon: '🌍',
                sunrise: '--',
                sunset: '--',
                city: cityName
            });
        } finally {
            setLoading(false);
        }
    };

    // Auto-detect location on component mount
    useEffect(() => {
        getUserLocation();
    }, []);

    // Fetch weather when city changes
    useEffect(() => {
        if (city) {
            fetchWeather(city);
        }
    }, [city]);

    if (detectingLocation) {
        return (
            <div className="weather-widget" style={{ background: 'linear-gradient(135deg,#0a2647,#144272)', color: '#fff', borderRadius: '3px', padding: '16px', marginBottom: '20px' }}>
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    <div>📍 Detecting your location...</div>
                    <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '8px' }}>Please allow location access</div>
                </div>
            </div>
        );
    }

    if (loading && !weather) {
        return (
            <div className="weather-widget" style={{ background: 'linear-gradient(135deg,#0a2647,#144272)', color: '#fff', borderRadius: '3px', padding: '16px', marginBottom: '20px' }}>
                <div style={{ textAlign: 'center', padding: '20px' }}>Loading weather...</div>
            </div>
        );
    }

    return (
        <div className="weather-widget" style={{ background: 'linear-gradient(135deg,#0a2647,#144272)', color: '#fff', borderRadius: '3px', padding: '16px', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '10px' }}>
                <div className="city" style={{ fontSize: '12px', letterSpacing: '2px', opacity: 0.7, textTransform: 'uppercase' }}>
                    📍 {weather?.city || city}
                    {locationDetected && (
                        <span style={{ fontSize: '10px', marginLeft: '5px', opacity: 0.6 }}>(Auto)</span>
                    )}
                </div>
                <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                        onClick={() => {
                            getUserLocation();
                            setShowCityInput(false);
                        }}
                        style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '11px', padding: '4px 8px', borderRadius: '5px' }}
                        title="Detect my location"
                    >
                        🎯 Detect
                    </button>
                    <button
                        onClick={() => setShowCityInput(!showCityInput)}
                        style={{ background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', cursor: 'pointer', fontSize: '11px', padding: '4px 8px', borderRadius: '5px' }}
                    >
                        {showCityInput ? 'Close' : 'Change'}
                    </button>
                </div>
            </div>

            {error && (
                <div style={{ fontSize: '11px', color: '#ffcccc', marginTop: '5px', textAlign: 'center' }}>
                    {error}
                </div>
            )}

            {showCityInput && (
                <div style={{ marginBottom: '10px', marginTop: '10px' }}>
                    <select
                        value={city}
                        onChange={(e) => {
                            setCity(e.target.value);
                            setShowCityInput(false);
                            setLocationDetected(false);
                        }}
                        style={{
                            width: '100%',
                            padding: '8px',
                            borderRadius: '5px',
                            border: 'none',
                            fontSize: '12px',
                            backgroundColor: '#fff',
                            color: '#333'
                        }}
                    >
                        {popularCities.map(c => (
                            <option key={c.name} value={c.name}>{c.displayName}</option>
                        ))}
                    </select>
                </div>
            )}

            <div className="temp" style={{ fontFamily: 'var(--ff-label)', fontSize: '52px', lineHeight: 1 }}>
                {weather?.temp}°
            </div>
            <div className="desc" style={{ fontSize: '14px', opacity: 0.8, marginTop: '4px' }}>
                {weather?.icon} {weather?.description}
            </div>
            <div className="weather-mini" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '12px', borderTop: '1px solid rgba(255,255,255,.2)', paddingTop: '10px', flexWrap: 'wrap', gap: '8px' }}>
                <span style={{ fontSize: '11px', textAlign: 'center', opacity: 0.8 }}>🌅 {weather?.sunrise}<br />Sunrise</span>
                <span style={{ fontSize: '11px', textAlign: 'center', opacity: 0.8 }}>💧 {weather?.humidity}%<br />Humidity</span>
                <span style={{ fontSize: '11px', textAlign: 'center', opacity: 0.8 }}>💨 {weather?.windSpeed} kmph<br />Wind</span>
                <span style={{ fontSize: '11px', textAlign: 'center', opacity: 0.8 }}>🌙 {weather?.sunset}<br />Sunset</span>
            </div>
        </div>
    );
};

export default WeatherWidget;